export enum StatusCodes {
    TicketNotFound = 4001,
    TicketCurrentlyProcessed = 4002
}